import './style.scss';
import React from 'react';

const Summary = ({
  callback = () => {
  }, questionList,
}) => {
  //   const styless = {
  //     cancelBtnWrapper: {
  //       position: "absolute",
  //       right: 15,
  //       top: 15,
  //       bottom: 0,
  //     },
  //     cancelIcon: {
  //       color: "#fff",
  //       fontSize: 30,
  //     },
  //   };

  return (
    <div class='modal fade model_summ'>
      <div className='modal-overlay'></div>
      <div class='modal-dialog model-lg '>
        <div class='modal-content'>
          <div class='modal-header'>
            <div className='cancel-btn-container' onClick={callback}>
              <i className='clos_btn'>
                <img
                  src={require('../../../../Assets/Images/Icons/close_icon.png')}
                  alt='close'
                />
              </i>
            </div>
            <div>
              <div className='btn-modal'>
                <p className='blue-btn sum_btn'>
                  Summary
                </p>
              </div>
            </div>
          </div>
          <div class='modal-body'>
            <div className='simulated_results'>
              <div className='card_det'>
                {questionList.map((question, index) => {
                  let que = question.question.split('<f>').join('___');
                  return (
                    <div key={index}>
                      <div className='Card_list'>
                        <h6>
                          <span>{index + 1}.</span>
                          {que}{' '}
                        </h6>
                        <p
                          className={
                            question.correct_incorrect_status === 1
                              ? 'card_correct'
                              : 'card_in_correct'
                          }
                        >
                          {question.correct_incorrect_status === 1
                            ? question.answerDescription
                            : question.incorrectDescription}{' '}
                        </p>
                      </div>
                      {/* {renderQuestion(index + 1)} */}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary;
